import { render } from "./NftPage.vue?vue&type=template&id=479b9107&scoped=true"
import script from "./NftPage.vue?vue&type=script&lang=js"
export * from "./NftPage.vue?vue&type=script&lang=js"

import "./NftPage.vue?vue&type=style&index=0&id=479b9107&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479b9107"]])

export default __exports__